// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"3343ab7a","568":"3343ab7a"}[chunkId] + ".chunk.js";
};